/* LodyFair winkelwagen-lade.
   Deel 1: cadeaumechaniek (gratis sokken vanaf de drempel).
   Deel 2: verzendbescherming als opt-in.
   Deel 3: geraamte — regels, aantallen, verwijderen, totalen, kortingscode.
   Deel 4: snelheid — optimistische weergave, gebundelde calls, regel-diffing.

   Kernregels:
   - Het subtotaal voor de drempel telt EXCLUSIEF het cadeau en EXCLUSIEF de
     verzendbescherming (anders koopt iemand zich met €3,95 naar de sokken toe).
   - Cadeau erbij zodra subtotaal >= drempel, eraf zodra het eronder zakt,
     aantal altijd terug naar 1; gesplitste cadeauregels worden samengevoegd.
   - Verzendbescherming is een opt-in toggle (EU-recht: standaard UIT, geen
     onthouden keuze — de stand volgt puur wat er nu in de winkelwagen zit).

   Snelheid: een klik op + of − past eerst de LOKALE winkelwagen aan en tekent
   die direct (geen netwerk in het zichtpad). Pas daarna gaat er één
   /cart/update.js de deur uit, met alle wijzigingen uit het klikvenster
   gebundeld. Regels worden bijgewerkt in plaats van opnieuw opgebouwd, zodat
   productfoto's niet opnieuw hoeven laden. */
(function () {
  var root = document.getElementById('LfCartDrawer');
  if (!root) return;

  /* DE CADEAULADDER

     Komt als lijst uit Liquid: per tier een drempel, een soort en een cadeau.
     Twee soorten:
       "vast"  — één variant, de klant kiest niets (sokken, boxershort)
       "keuze" — de klant kiest zelf uit een lijst (voetbalshirt: welk shirt
                 én welke maat)

     Bij een keuze-tier staat er pas een cadeau in de wagen zodra de klant
     gekozen heeft. Dat is bewust: een shirt in maat M in iemands wagen leggen
     die L draagt is erger dan even niets.

     Valt de lijst weg of is hij stuk, dan blijft er precies één tier over met
     de sokken erin — dan gedraagt de wagen zich als voorheen. */
  var TIERS = [];
  try {
    TIERS = JSON.parse(root.dataset.tiers || '[]');
  } catch (e) { TIERS = []; }
  if (!TIERS.length) {
    TIERS = [{
      id: 'sokken', soort: 'vast',
      drempel: parseInt(root.dataset.drempel, 10),
      variant: parseInt(root.dataset.giftVariant, 10),
      label: 'Sokken', kort: ''
    }];
  }
  TIERS.sort(function (a, b) { return a.drempel - b.drempel; });

  /* Wat de klant bij een keuze-tier gekozen heeft. Blijft staan zolang het
     tabblad open is, zodat het venster halverwege dicht kan en de keuze er bij
     heropenen nog is. sessionStorage en niet localStorage: een keuze hoort bij
     deze winkelsessie, niet bij dit apparaat voor altijd. */
  var KEUZESLEUTEL = 'lfCadeaukeuzes';
  var keuzes = {};
  try { keuzes = JSON.parse(window.sessionStorage.getItem(KEUZESLEUTEL) || '{}'); }
  catch (e) { keuzes = {}; }

  function bewaarKeuzes() {
    try { window.sessionStorage.setItem(KEUZESLEUTEL, JSON.stringify(keuzes)); }
    catch (e) { /* privémodus: dan alleen in het geheugen */ }
  }

  /* De variant die bij deze tier hoort, of 0 als er (nog) geen is. */
  function tierVariant(tier) {
    if (tier.soort === 'keuze') return parseInt(keuzes[tier.id], 10) || 0;
    return parseInt(tier.variant, 10) || 0;
  }

  var GIFT = parseInt(root.dataset.giftVariant, 10);
  var BESCHERM = parseInt(root.dataset.beschermingVariant, 10) || 0;
  var DREMPEL = parseInt(root.dataset.drempel, 10);
  var TEKST_VOOR = root.dataset.tekstVoor || 'Nog {bedrag} tot je gratis sokken 🧦';
  var TEKST_NA = root.dataset.tekstNa || 'Gelukt! Je gratis sokken zijn toegevoegd';
  var TEKST_GRATIS = root.dataset.tekstGratis || 'GRATIS';
  var TEKST_VERWIJDEREN = root.dataset.tekstVerwijderen || 'Verwijderen';
  var CADEAU_BEWAKING = root.dataset.cadeauBewaking === 'true';
  var CHECKOUT_URL = root.dataset.checkoutUrl || '/cart/checkout';
  var WACHTTIJD = 280; // ms waarin snel achter elkaar klikken wordt gebundeld

  var elAantal = root.querySelector('[data-lf-aantal]');
  var elTekst = root.querySelector('[data-lf-voortgang-tekst]');
  var elBalk = root.querySelector('[data-lf-balk]');
  var elVoortgang = root.querySelector('.lf-cart__voortgang');
  var elRegels = root.querySelector('[data-lf-regels]');
  var elSubtotaal = root.querySelector('[data-lf-subtotaal]');
  var elTotaal = root.querySelector('[data-lf-totaal]');
  var elKortingrij = root.querySelector('[data-lf-kortingrij]');
  var elKortingbedrag = root.querySelector('[data-lf-kortingbedrag]');
  var elAfrekenen = root.querySelector('[data-lf-afrekenen]');
  var elBescherming = root.querySelector('[data-lf-bescherming]');
  var elBeschermingToggle = root.querySelector('[data-lf-bescherming-toggle]');

  var keten = Promise.resolve();
  var cart = null;          // laatst bekende winkelwagen (met optimistische aanpassingen)
  var wachtend = {};        // regelsleutel -> gewenst aantal, nog niet verstuurd
  var timer = null;
  var kortingscode = '';

  try {
    kortingscode = window.sessionStorage.getItem('lfKortingscode') || '';
  } catch (e) {
    kortingscode = '';
  }

  function geld(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  var STAFFELSECTIE = 'lodyfair-bundel-melding';

  function api(url, body) {
    /* De staffelmelding heeft de collecties van elk artikel nodig en die geeft
       /cart.js niet terug. Daarom vragen we hem als sectie mee in dezelfde
       aanroep — dat scheelt een extra netwerkverzoek per wijziging. */
    /* 7 september 2026: de staffelmelding is op 31 augustus verwijderd en de
       sectie lodyfair-bundel-melding bestaat niet meer. De sectie meesturen
       leverde alleen nog een 404 op; STAFFELSECTIE blijft staan voor
       zetStaffelmelding, die dan netjes de lege houder leegt. */

    var opts = body
      ? { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) }
      : {};
    return fetch(url, opts).then(function (r) {
      if (!r.ok) throw new Error('cart-api ' + r.status);
      return r.json();
    }).then(function (data) {
      if (data && data.sections && data.sections[STAFFELSECTIE]) {
        zetStaffelmelding(data.sections[STAFFELSECTIE]);
      }
      return data;
    });
  }

  /* De sectie komt binnen als een compleet stukje HTML met een eigen wikkel van
     Shopify eromheen; we pakken alleen onze eigen div eruit. */
  function zetStaffelmelding(html) {
    var houder = root.querySelector('[data-lf-staffelhouder]');
    if (!houder) return;
    var hulp = document.createElement('div');
    hulp.innerHTML = html;
    var nieuw = hulp.querySelector('[data-lf-staffelmelding]');
    if (!nieuw) { houder.innerHTML = ''; return; }

    /* Tweede slot op de deur. De sectie controleert zelf al of de korting echt
       is toegekend, maar Liquid-wijzigingen kunnen even blijven hangen in de
       weergave van Shopify terwijl dit bestand meteen ververst. Krijgt geen
       enkele gewone regel korting, dan is er niets "gelukt" en halen we die
       melding weg. De cadeauregel telt niet mee: die is altijd 100% af. */
    if (!heeftEchteKorting()) {
      var gehaald = nieuw.querySelectorAll('.lf-cart__staffel--gehaald');
      for (var i = 0; i < gehaald.length; i++) gehaald[i].parentNode.removeChild(gehaald[i]);
    }
    houder.innerHTML = nieuw.outerHTML;
  }

  function heeftEchteKorting() {
    if (!cart || !cart.items) return false;
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      if (isExtra(item)) continue;
      var toegekend = item.line_level_discount_allocations || [];
      for (var j = 0; j < toegekend.length; j++) {
        if (toegekend[j].amount > 0) return true;
      }
    }
    return false;
  }

  function haalCart() { return api('/cart.js'); }

  /* ALLE VARIANTEN DIE OOIT EEN CADEAU KUNNEN ZIJN.

     Niet alleen de variant die er nu ligt: ook elke maat van elk shirt uit de
     keuzecollectie. Anders zou een gekozen shirt meetellen voor de drempel
     waarmee de klant het verdiend heeft — en dan kan hij door zijn cadeau te
     kiezen een volgend cadeau vrijspelen. */
  var CADEAUVARIANTEN = (function () {
    var set = {};
    TIERS.forEach(function (t) {
      if (t.soort === 'vast' && t.variant) set[t.variant] = true;
      (t.opties || []).forEach(function (o) {
        (o.maten || []).forEach(function (m) { set[m.id] = true; });
      });
    });
    return set;
  })();

  /* Cadeaus en verzendbescherming zijn "extra's": geen echte producten. Ze
     tellen niet mee voor de drempels en krijgen geen plus- en minknop. */
  function isExtra(item) {
    return !!CADEAUVARIANTEN[item.variant_id] || item.variant_id === BESCHERM;
  }

  function subtotaalExclCadeau(c) {
    return c.items.reduce(function (som, item) {
      /* original_line_price = de prijs VOOR regelkorting. De kortingsfunctie
         meet de sokkendrempel op precies datzelfde bedrag (cost.subtotalAmount),
         zodat de balk en de kassa niet uit elkaar kunnen lopen. Zou hier
         final_line_price staan, dan zou een klant die door de bundelkorting
         onder de €100 zakt zijn balk zien terugvallen terwijl hij de sokken
         gewoon houdt. */
      return isExtra(item) ? som : som + item.original_line_price;
    }, 0);
  }

  function aantalEchteProducten(c) {
    return c.items.reduce(function (n, item) {
      return isExtra(item) ? n : n + 1;
    }, 0);
  }

  function sleutelsVan(c, variantId) {
    return c.items.filter(function (i) { return i.variant_id === variantId; })
      .map(function (i) { return i.key; });
  }

  /* Onthoudt bij welke winkelwagen het cadeau niet gratis bleek. Sleutel is het
     subtotaal plus het aantal regels: verandert de klant iets, dan proberen we
     het gewoon opnieuw. */
  var geweigerdBij = {};   // per tier: bij welke samenstelling het cadeau niet gratis bleek
  function sleutel(sub, echt) { return sub + ':' + echt; }

  function beschermingItem(c) {
    for (var i = 0; i < c.items.length; i++) {
      if (c.items[i].variant_id === BESCHERM) return c.items[i];
    }
    return null;
  }

  function itemOpSleutel(c, key) {
    for (var i = 0; i < c.items.length; i++) {
      if (c.items[i].key === key) return c.items[i];
    }
    return null;
  }

  function heeftIets(obj) {
    for (var k in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, k)) return true;
    }
    return false;
  }

  /* Wat er aan de EXTRA'S moet veranderen om de winkelwagen kloppend te maken:
     cadeau erin of eruit, nooit meer dan één van elk, allebei op aantal 1.

     Deze functie verstuurt zelf niets; ze geeft een updates-object terug.
     Daardoor kan dezelfde beslissing op twee manieren gebruikt worden:
       - meeliften op de wijziging die de klant toch al veroorzaakt (stuur)
       - alsnog rechtzetten in één gebundelde aanroep (verzoen)

     Waarom: verzoen() deed vroeger één aanroep per ronde. Het aantal ophogen
     én het cadeau erbij waren dan twee rondgangen achter elkaar, en met de
     controle erachteraan soms drie. Alles wat in één updates-object past, gaat
     nu in één aanroep de deur uit — update.js accepteert regelsleutels en
     variant-id's door elkaar heen.

     Wat hier NIET beslist kan worden: of het cadeau ook echt gratis is. Dat
     staat pas in het antwoord van de server (de toegekende korting op de
     cadeauregel). Die stap blijft dus apart, in verzoen(). */
  function bepaalExtras(c) {
    var taken = {};
    if (!c || !c.items) return taken;

    var bescherm = BESCHERM ? sleutelsVan(c, BESCHERM) : [];
    var i, t;

    /* Alle cadeauregels die er nu liggen, per tier gegroepeerd. Een tier kan
       meerdere regels hebben: Shopify splitst een regel zodra er een korting
       op zit (zie de notitie bij verzoen). */
    function regelsVan(tier) {
      var v = tierVariant(tier);
      if (!v) return [];
      return sleutelsVan(c, v);
    }

    // Geen echte producten meer: extra's mogen niet alleen achterblijven.
    if (aantalEchteProducten(c) === 0) {
      c.items.forEach(function (item) {
        if (isExtra(item)) taken[item.key] = 0;
      });
      return taken;
    }

    var sub = subtotaalExclCadeau(c);
    var echt = aantalEchteProducten(c);

    for (var n = 0; n < TIERS.length; n++) {
      t = TIERS[n];
      var regels = regelsVan(t);

      /* Wil de klant dit cadeau, en mag het? Drie voorwaarden:
         - de drempel is gehaald
         - bij een keuze-tier is er ook echt gekozen
         - het is bij deze samenstelling niet al eens geweigerd omdat de
           staffelkorting voordeliger bleek (anders ontstaat er een lus) */
      var wil = sub >= t.drempel && tierVariant(t) > 0;
      if (wil && CADEAU_BEWAKING && geweigerdBij[t.id] === sleutel(sub, echt)) {
        wil = false;
      }

      if (!wil) {
        for (i = 0; i < regels.length; i++) taken[regels[i]] = 0;
      } else if (!regels.length) {
        /* Op variant-id in plaats van regelsleutel: die regel bestaat nog niet.
           update.js maakt hem dan aan en geeft de hele wagen terug. */
        taken[tierVariant(t)] = 1;
      } else {
        for (i = 1; i < regels.length; i++) taken[regels[i]] = 0;
        var eerste = itemOpSleutel(c, regels[0]);
        if (eerste && eerste.quantity !== 1) taken[regels[0]] = 1;
      }
    }

    /* Een cadeauvariant die bij geen enkele actieve tier hoort — bijvoorbeeld
       een shirt in een maat die de klant net heeft omgeruild, of een cadeau
       dat iemand zelf via het productadres in zijn wagen heeft gelegd — gaat
       eruit. Dit is de deur die handmatig toevoegen dichthoudt. */
    c.items.forEach(function (item) {
      if (!isExtra(item) || item.variant_id === BESCHERM) return;
      if (taken[item.key] !== undefined) return;
      var hoortErbij = false;
      for (var k = 0; k < TIERS.length; k++) {
        if (tierVariant(TIERS[k]) === item.variant_id && sub >= TIERS[k].drempel) hoortErbij = true;
      }
      if (!hoortErbij) taken[item.key] = 0;
    });

    // Bescherming: nooit meer dan één regel, nooit meer dan één stuks.
    for (i = 1; i < bescherm.length; i++) taken[bescherm[i]] = 0;
    if (bescherm.length) {
      var b = itemOpSleutel(c, bescherm[0]);
      if (b && b.quantity !== 1) taken[bescherm[0]] = 1;
    }

    return taken;
  }

  /* Verzoen cadeau en bescherming met de cartinhoud; levert de definitieve
     cart op. Shopify kan de cadeauregel splitsen (gratis deel + betaald deel),
     dus meerdere cadeauregels worden teruggebracht tot precies één met aantal 1.
     Werkt op regelsleutels, niet op regelnummers: die verschuiven namelijk
     zodra er een regel verdwijnt. */
  function verzoen(c, ronde) {
    ronde = ronde || 0;
    if (ronde > 4) return Promise.resolve(c); // vangrail tegen lussen

    function verder(p) {
      return p
        .then(function (n) { return verzoen(n, ronde + 1); })
        .catch(function () {
          /* Bijvoorbeeld: het cadeau is uitverkocht. Dan weten we niet meer
             zeker hoe de wagen eruitziet, dus halen we hem op in plaats van
             verder te tekenen met een gok. Alleen in de foutafhandeling, dus
             het kost in het normale geval niets. */
          return haalCart().catch(function () { return c; });
        });
    }

    /* Vorm en aantallen van de extra's: alles wat er mis is, in één aanroep.
       Heeft de aanroeper bepaalExtras() al meegestuurd — dat doet stuur() —
       dan valt hier niets meer te doen en gaat er geen enkel verzoek uit. */
    var taken = bepaalExtras(c);
    if (heeftIets(taken)) return verder(api('/cart/update.js', { updates: taken }));

    /* IS HET CADEAU WEL EEN CADEAU?

       De gratis sokken en de staffelkortingen staan allebei op "combineert
       niet met productkortingen". Shopify kiest dan de voordeligste voor de
       klant en laat de ander volledig vervallen. Boven ongeveer EUR 200 aan
       kortingsartikelen wint de staffel, en dan rekent de kassa de sokken
       gewoon door: de lade zou een artikel van EUR 29,95 in de wagen leggen
       dat de klant betaalt en dat hij niet gevraagd heeft.

       We voorspellen dat kantelpunt niet, we lezen het af. Krijgt de
       cadeauregel niet zijn volledige prijs aan korting toegekend, dan is het
       geen cadeau en gaat hij eruit. Dit kan pas hierboven niet meegenomen
       worden: het antwoord staat alleen in wat de server terugstuurt. */
    if (CADEAU_BEWAKING) {
      var stempel = sleutel(subtotaalExclCadeau(c), aantalEchteProducten(c));
      for (var w = 0; w < TIERS.length; w++) {
        var vw = tierVariant(TIERS[w]);
        if (!vw) continue;
        var regelsW = sleutelsVan(c, vw);
        if (regelsW.length !== 1) continue;
        var itemW = itemOpSleutel(c, regelsW[0]);
        if (!itemW || itemW.quantity !== 1) continue;
        var afW = (itemW.line_level_discount_allocations || [])
          .reduce(function (t, a) { return t + a.amount; }, 0);
        if (afW < itemW.original_line_price) {
          geweigerdBij[TIERS[w].id] = stempel;
          var eruitW = {};
          eruitW[regelsW[0]] = 0;
          return verder(api('/cart/update.js', { updates: eruitW }));
        }
      }
    }

    return Promise.resolve(c);
  }

  /* ================= CADEAULADDER, KNOP EN KEUZEBLAD =================

     Alles hieronder verschijnt pas bij meer dan één tier. Met alleen de sokken
     blijft de winkelwagen exact zoals hij was: één zin en één balk.
  ================================================================== */

  var elLadder = root.querySelector('[data-lf-ladder]');
  var elCadeauknop = root.querySelector('[data-lf-cadeauknop]');
  var elCadeauknopTekst = root.querySelector('[data-lf-cadeauknop-tekst]');
  var elBlad = root.querySelector('[data-lf-cadeaublad]');
  var elBladInhoud = root.querySelector('[data-lf-cadeaublad-inhoud]');
  var elBladPil = root.querySelector('[data-lf-cadeaublad-pil]');
  var elBladVerder = root.querySelector('[data-lf-cadeaublad-verder]');
  var elBladTerug = root.querySelector('[data-lf-cadeaublad-terug]');

  var LADDER_AAN = TIERS.length > 1;
  /* De CSS moet weten of er een ladder staat: de gehaald-stand kent dan een
     andere opmaak (de ladder blijft staan, de balk-regels gelden niet). */
  root.classList.toggle('lf-heeft-ladder', LADDER_AAN);
  /* Bij meerdere cadeaus is de sokken-specifieke gelukt-zin uit de
     instellingen fout; dan deze neutrale. */
  var TEKST_NA_LADDER = root.dataset.tekstNaLadder || 'Gelukt! Je cadeaus liggen in je winkelwagen';
  var T = {
    stap: root.dataset.tekstStap || 'Cadeau [n] van [t]',
    stapMaat: root.dataset.tekstStapMaat || 'Cadeau [n] van [t] · maat',
    verder: root.dataset.tekstVerder || 'Volgende cadeau',
    bevestigen: root.dataset.tekstBevestigen || 'Bevestigen',
    kiesMaat: root.dataset.tekstKiesMaat || 'Kies je maat',
    gratis: root.dataset.tekstCadeauGratis || 'Gratis',
    uitverkocht: root.dataset.tekstCadeauUit || 'Uitverkocht',
    knopEen: root.dataset.tekstKnopEen || 'Kies je gratis cadeau',
    knopMeer: root.dataset.tekstKnopMeer || 'Kies je [n] gratis cadeaus',
    geenOpties: root.dataset.tekstGeenOpties || 'Er zijn op dit moment geen cadeaus beschikbaar.',
    nogEen: root.dataset.tekstNogEen || 'Nog 1 cadeau te kiezen',
    nogMeer: root.dataset.tekstNogMeer || 'Nog [n] cadeaus te kiezen'
  };

  /* Welke tiers zijn vrijgespeeld bij dit subtotaal? */
  function vrijgespeeld(sub) {
    return TIERS.filter(function (t) { return sub >= t.drempel; });
  }

  /* Een keuze-tier telt pas als afgerond zodra er een variant gekozen is. */
  function nogTeKiezen(sub) {
    return vrijgespeeld(sub).filter(function (t) {
      return t.soort === 'keuze' && !tierVariant(t);
    });
  }

  /* Heeft dit shirt nog een maat op voorraad? */
  function optieLeverbaar(o) {
    return (o.maten || []).some(function (m) { return m.op; });
  }

  function ontsmet(s) {
    return String(s).replace(/[<>&"]/g, function (c) {
      return { '<': '&lt;', '>': '&gt;', '&': '&amp;', '"': '&quot;' }[c];
    });
  }

  function tekenLadder(sub) {
    if (!elLadder) return;
    if (!LADDER_AAN) { elLadder.hidden = true; return; }
    elLadder.hidden = false;

    var eerstVolgende = TIERS.filter(function (t) { return sub < t.drempel; })[0];
    var html = '';
    var vorigeDrempel = 0;
    TIERS.forEach(function (t) {
      var gehaald = sub >= t.drempel;
      var volgende = eerstVolgende && eerstVolgende.id === t.id;
      /* De lijn naar deze mijlpaal vult mee: het stuk tussen de vorige
         drempel en deze, naar rato van het subtotaal. */
      var deel = t.drempel > vorigeDrempel
        ? Math.max(0, Math.min(1, (sub - vorigeDrempel) / (t.drempel - vorigeDrempel)))
        : 1;
      html += '<div class="lf-cart__sport' + (gehaald ? ' is-gehaald' : '') +
        (volgende ? ' is-volgende' : '') + '">' +
        '<span class="lf-cart__sport-lijn"><span class="lf-cart__sport-lijn-vulling" style="width:' + Math.round(deel * 100) + '%"></span></span>' +
        '<span class="lf-cart__sport-bol">' +
          (gehaald
            ? '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.4" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12l6 6L20 6"/></svg>'
            : '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M20 12v9H4v-9"/><path d="M2 7h20v5H2z"/><path d="M12 21V7"/></svg>') +
        '</span>' +
        '<span class="lf-cart__sport-naam">Gratis ' + ontsmet(t.label || '').toLowerCase() + '</span>' +
        '<span class="lf-cart__sport-bedrag">' + ontsmet(t.kort || geld(t.drempel)) + '</span>' +
        '</div>';
      vorigeDrempel = t.drempel;
    });
    elLadder.innerHTML = html;
  }

  function tekenCadeauknop(sub) {
    if (!elCadeauknop) return;
    if (!LADDER_AAN) { elCadeauknop.hidden = true; return; }

    /* De knop gaat alleen over cadeaus waar écht iets te kiezen valt. Een tier
       met één vast cadeau ligt al in de wagen; daar hoeft niemand op te
       klikken. Valt er niets te kiezen, dan blijft de voortgangszin over. */
    var open = nogTeKiezen(sub);
    if (!open.length) { elCadeauknop.hidden = true; return; }

    elCadeauknop.hidden = false;
    elCadeauknopTekst.textContent = open.length === 1
      ? T.knopEen
      : T.knopMeer.replace('[n]', open.length);
  }

  /* ---------- het keuzeblad ---------- */

  var bladTiers = [];     // welke tiers deze ronde langskomen
  var bladStap = 0;       // index in bladTiers
  var bladShirt = null;   // gekozen shirt binnen de maatstap, of null

  function openBlad() {
    var sub = cart ? subtotaalExclCadeau(cart) : 0;
    bladTiers = vrijgespeeld(sub).filter(function (t) { return t.soort === 'keuze'; });
    if (!bladTiers.length) return;
    bladStap = 0;
    bladShirt = null;
    elBlad.hidden = false;
    /* Eerst tonen, dan een herberekening afdwingen, dan pas de klasse. Zonder
       die tussenstap slaat de browser de overgang over en klapt het blad er
       zonder animatie in.

       Bewust géén requestAnimationFrame: die staat stil in een tabblad dat op
       de achtergrond draait, en dan blijft het blad onder de onderrand hangen
       terwijl het wel "open" heet. Een afgedwongen herberekening werkt altijd. */
    void elBlad.offsetWidth;
    elBlad.classList.add('is-open');
    tekenBlad();
  }

  function sluitBlad() {
    elBlad.classList.remove('is-open');
    window.setTimeout(function () { elBlad.hidden = true; }, 220);
  }

  function tekenBlad() {
    var tier = bladTiers[bladStap];
    if (!tier) { sluitBlad(); return; }

    var laatste = bladStap === bladTiers.length - 1;
    var nr = bladStap + 1, totaal = bladTiers.length;

    elBladTerug.hidden = !bladShirt;
    elBladPil.textContent = (bladShirt ? T.stapMaat : T.stap)
      .replace('[n]', nr).replace('[t]', totaal);

    var opties = (tier.opties || []).filter(function (o) { return (o.maten || []).length; });

    if (!opties.length || !opties.some(optieLeverbaar)) {
      /* Alles op: geen leeg blad, maar uitleg. */
      elBladInhoud.innerHTML = '<p class="lf-cadeaublad__melding">' + veiligHtml(T.geenOpties) + '</p>';
      elBladVerder.disabled = true;
      elBladVerder.textContent = laatste ? T.bevestigen : T.verder;
      return;
    }

    if (!bladShirt) {
      // scherm 1: het raster
      var r = '<div class="lf-cadeauraster">';
      opties.forEach(function (o, i) {
        var uit = !optieLeverbaar(o);
        var gekozenId = tierVariant(tier);
        var isGekozen = (o.maten || []).some(function (m) { return m.id === gekozenId; });
        r += '<button type="button" class="lf-cadeautegel' + (uit ? ' is-uit' : '') +
          (isGekozen ? ' is-gekozen' : '') + '" data-lf-tegel="' + i + '"' + (uit ? ' disabled' : '') + '>' +
          '<img src="' + veiligHtml(o.foto || '') + '" alt="" loading="lazy">' +
          '<span class="lf-cadeautegel__naam">' + veiligHtml(o.titel) + '</span>' +
          (uit ? '<span class="lf-cadeautegel__uit">' + veiligHtml(T.uitverkocht) + '</span>' : '') +
          '</button>';
      });
      r += '</div>';
      elBladInhoud.innerHTML = r;
      elBladVerder.disabled = !tierVariant(tier);
      elBladVerder.textContent = laatste ? T.bevestigen : T.verder;
      return;
    }

    // scherm 2: de maten van het gekozen shirt
    var o2 = bladShirt;
    var gekozen = tierVariant(tier);
    var m = '<div class="lf-cadeaumaat__kop">' +
      '<img src="' + veiligHtml(o2.foto || '') + '" alt="" loading="lazy">' +
      '<span class="lf-cadeaumaat__naam">' + veiligHtml(o2.titel) + '</span></div>' +
      '<p class="lf-cadeaublad__melding" style="padding:0 0 10px;text-align:left">' + veiligHtml(T.kiesMaat) + '</p>' +
      '<div class="lf-cadeaumaat__rij">';
    (o2.maten || []).forEach(function (maat) {
      m += '<button type="button" class="lf-cadeaumaat__knop' + (maat.id === gekozen ? ' is-gekozen' : '') +
        '" data-lf-maat="' + maat.id + '"' + (maat.op ? '' : ' disabled') + '>' +
        veiligHtml(maat.maat) + '</button>';
    });
    m += '</div>';
    elBladInhoud.innerHTML = m;
    elBladVerder.disabled = !gekozen;
    elBladVerder.textContent = laatste ? T.bevestigen : T.verder;
  }

  function veiligHtml(t) {
    return String(t == null ? '' : t)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  if (elBlad) {
    elBlad.addEventListener('click', function (e) {
      if (e.target.closest('[data-lf-cadeaublad-sluit]')) { sluitBlad(); return; }

      var terug = e.target.closest('[data-lf-cadeaublad-terug]');
      if (terug) { bladShirt = null; tekenBlad(); return; }

      var tegel = e.target.closest('[data-lf-tegel]');
      if (tegel) {
        var tier = bladTiers[bladStap];
        bladShirt = (tier.opties || []).filter(function (o) { return (o.maten || []).length; })[
          parseInt(tegel.getAttribute('data-lf-tegel'), 10)];
        tekenBlad();
        return;
      }

      var maat = e.target.closest('[data-lf-maat]');
      if (maat) {
        var t2 = bladTiers[bladStap];
        keuzes[t2.id] = parseInt(maat.getAttribute('data-lf-maat'), 10);
        bewaarKeuzes();
        tekenBlad();
        return;
      }

      if (e.target.closest('[data-lf-cadeaublad-verder]')) {
        if (bladStap < bladTiers.length - 1) {
          bladStap++; bladShirt = null; tekenBlad();
        } else {
          sluitBlad();
          sync();   // de keuze in de wagen laten landen
        }
      }
    });
  }

  if (elCadeauknop) {
    elCadeauknop.addEventListener('click', openBlad);
  }

  /* De ladder blijft staan bij het scrollen — hij zit buiten het scrollgebied.
     Zodra er gescrold wordt knijpt hij samen, zodat hij minder van het scherm
     inneemt zonder helemaal te verdwijnen. */
  (function () {
    var scroller = root.querySelector('.lf-cart__scroll');
    if (!scroller) return;
    var bezig = false;
    scroller.addEventListener('scroll', function () {
      if (bezig) return;
      bezig = true;
      requestAnimationFrame(function () {
        bezig = false;
        root.classList.toggle('is-gescrold', scroller.scrollTop > 12);
      });
    }, { passive: true });
  })();

  /* ---------- maten en voorraad ----------

     Gevoed door /cart?view=maten (templates/cart.maten.liquid): per regel de
     voorraad van de eigen variant en de lijst zustervarianten. Daarmee kan de
     lade twee dingen die /cart.js niet kan:

       1. een maatkiezer tonen — de klant wisselt van maat zonder de regel te
          verwijderen en opnieuw te zoeken
       2. de +knop begrenzen op de voorraad — /cart/update.js controleert die
          namelijk NIET (gemeten 29 aug 2026: 2 stuks in de wagen bij voorraad
          1, en de klant strandt dan pas op de voorraadpagina van de checkout)

     De kaart wordt ververst bij het openen van de lade en na elke geslaagde
     schrijfactie. Tussen twee verversingen kan hij heel even achterlopen; de
     kassa blijft de laatste rechter. */
  var MATEN = {};
  var matenBezig = false;

  function haalMaten() {
    if (matenBezig) return;
    matenBezig = true;
    fetch('/cart?view=maten', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (lijst) {
        matenBezig = false;
        if (!lijst) return;
        MATEN = {};
        lijst.forEach(function (m) { MATEN[m.key] = m; });
        // de regels die er al staan bijwerken met wat we nu weten
        var kinderen = elRegels.querySelectorAll('[data-lf-regel]');
        for (var i = 0; i < kinderen.length; i++) {
          var item = vindItem(kinderen[i].getAttribute('data-lf-regel'));
          if (item) vulMaat(kinderen[i], item, item.variant_id === GIFT);
        }
      })
      .catch(function () { matenBezig = false; });
  }

  /* Grens voor de +knop: het aantal dat er van deze variant nog bij mag.
     null = geen grens bekend (onbeheerd, doorverkoop toegestaan, of de
     informatie is er simpelweg nog niet). */
  function voorraadGrens(key) {
    var m = MATEN[key];
    if (!m) return null;
    if (m.beheerd !== 'shopify' || m.beleid !== 'deny') return null;
    if (typeof m.voorraad !== 'number' || m.voorraad < 0) return null;
    return m.voorraad;
  }

  /* Korte melding op de regel zelf. Verdwijnt vanzelf; wie doorklikt krijgt
     hem gewoon opnieuw. */
  var foutTimers = {};
  function regelFout(key, tekst) {
    var el = elRegels.querySelector('[data-lf-regel="' + key + '"] [data-lf-regelfout]');
    if (!el) return;
    el.textContent = tekst;
    el.hidden = false;
    if (foutTimers[key]) clearTimeout(foutTimers[key]);
    foutTimers[key] = setTimeout(function () { el.hidden = true; }, 5000);
  }

  /* De maatkiezer op één regel. Een gewone <select>: werkt met toetsenbord en
     schermlezer zonder eigen bouwwerk, en op mobiel opent hij het native
     maatwiel. Alleen zichtbaar als er echt iets te kiezen valt: minstens één
     ANDERE variant op voorraad. */
  function vulMaat(el, item, isCadeau) {
    var vak = el.querySelector('[data-lf-maat]');
    if (!vak) return;

    var m = MATEN[item.key];
    /* Ook regels die gratis zijn geworden (cadeaus van welke tier dan ook)
       krijgen geen kiezer: wisselen zou er een BETAALDE regel van maken —
       add.js kent de cadeaukorting niet. De cadeaumechaniek beheert die
       regels zelf. */
    if (isCadeau || item.final_line_price === 0 || item.variant_id === BESCHERM ||
        !m || !m.varianten || m.varianten.length < 2) {
      vak.hidden = true;
      return;
    }

    /* let op: 'opties' en niet 'keuzes' — die naam is al bezet door de
       cadeaukeuzes bovenaan dit bestand */
    var opties = m.varianten.filter(function (v) {
      return v.beschikbaar || v.id === item.variant_id;
    });
    var anderen = opties.filter(function (v) { return v.id !== item.variant_id; });
    if (!anderen.length) { vak.hidden = true; return; }

    /* Alleen opnieuw bouwen als de inhoud echt veranderd is — vulRegel draait
       bij elke hertekening en een select die steeds opnieuw opgebouwd wordt
       verliest zijn focus midden in het kiezen. */
    var handtekening = item.variant_id + '|' + opties.map(function (v) { return v.id; }).join(',');
    if (vak.getAttribute('data-handtekening') === handtekening) { vak.hidden = false; return; }
    vak.setAttribute('data-handtekening', handtekening);

    var select = document.createElement('select');
    select.className = 'lf-cart__maat-select';
    select.setAttribute('aria-label', 'Andere maat of uitvoering kiezen');
    select.setAttribute('data-lf-maat-select', '');
    opties.forEach(function (v) {
      var o = document.createElement('option');
      o.value = v.id;
      o.textContent = v.titel + (v.id === item.variant_id ? '' : (v.beschikbaar ? '' : ' — uitverkocht'));
      if (v.id === item.variant_id) o.selected = true;
      select.appendChild(o);
    });

    vak.innerHTML = '';
    vak.appendChild(select);
    vak.hidden = false;
  }

  /* Wisselen van variant: nieuwe erbij, oude eruit — in die volgorde. Mislukt
     het toevoegen (uitverkocht in de tussentijd), dan blijft de oude regel
     gewoon staan en meldt de regel wat er aan de hand is. */
  function wisselMaat(key, nieuwId) {
    var item = vindItem(key);
    if (!item || item.variant_id === nieuwId) return;

    markeerBezig(key, true);

    var body = { items: [{ id: nieuwId, quantity: item.quantity }] };
    if (item.properties && Object.keys(item.properties).length) {
      body.items[0].properties = item.properties;
    }

    inKeten(function () {
      return api('/cart/add.js', body)
        .then(function () {
          var updates = {};
          updates[key] = 0;
          return api('/cart/update.js', { updates: updates });
        })
        .then(function (c) { cart = c; teken(c); allesKlaar(); haalMaten(); })
        .catch(function (fout) {
          allesKlaar();
          // de select terug naar de oude stand, anders liegt hij
          var vak = elRegels.querySelector('[data-lf-regel="' + key + '"] [data-lf-maat-select]');
          if (vak) vak.value = String(item.variant_id);
          regelFout(key, (fout && fout.description) || 'Die maat is net uitverkocht.');
        });
    });
  }

  /* ---------- tekenen ---------- */

  function werkBubbelBij(aantal) {
    var nummers = document.querySelectorAll('.cart-link__bubble-num');
    for (var i = 0; i < nummers.length; i++) nummers[i].textContent = aantal;
    var bollen = document.querySelectorAll('.cart-link__bubble');
    for (var j = 0; j < bollen.length; j++) {
      bollen[j].classList.toggle('cart-link__bubble--visible', aantal > 0);
    }
    // gouden rondje met het aantal (mobiele header)
    var rondjes = document.querySelectorAll('[data-lf-cart-telling]');
    for (var k = 0; k < rondjes.length; k++) {
      rondjes[k].textContent = aantal;
      rondjes[k].hidden = aantal === 0;
    }
  }

  function maakRegel(item) {
    var el = document.createElement('div');
    el.className = 'lf-cart__regel';
    el.setAttribute('data-lf-regel', item.key);

    var img = document.createElement('img');
    img.loading = 'lazy';
    img.alt = '';
    if (item.image) img.src = item.image.replace(/(\.[a-z]{3,4})(\?|$)/, '_120x$1$2');
    el.appendChild(img);

    var info = document.createElement('div');
    info.className = 'lf-cart__regel-info';
    info.innerHTML =
      '<span class="lf-cart__gratis-label" data-lf-label hidden></span>' +
      '<p class="lf-cart__regel-titel" data-lf-titel></p>' +
      '<p class="lf-cart__regel-variant" data-lf-variant hidden></p>' +
      '<div class="lf-cart__stepper" data-lf-stepper>' +
      '<button type="button" data-lf-stap="-1" aria-label="Minder">−</button>' +
      '<span data-lf-hoeveel>1</span>' +
      '<button type="button" data-lf-stap="1" aria-label="Meer">+</button>' +
      '</div>' +
      /* Maatkiezer en regel-melding. Beide beginnen verborgen; vulMaat() zet ze
         aan zodra de voorraadinformatie binnen is. */
      '<div class="lf-cart__maat" data-lf-maat hidden></div>' +
      '<p class="lf-cart__regelfout" data-lf-regelfout hidden role="alert"></p>';
    el.appendChild(info);

    var rechts = document.createElement('div');
    rechts.className = 'lf-cart__regel-rechts';
    rechts.innerHTML =
      '<button type="button" class="lf-cart__verwijder" data-lf-verwijder aria-label="' + TEKST_VERWIJDEREN + '">' +
      '<svg viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true"><path d="M1 1l12 12M13 1L1 13"/></svg>' +
      '</button>' +
      '<div class="lf-cart__regel-prijs" data-lf-prijs></div>';
    el.appendChild(rechts);

    return el;
  }

  function vulRegel(el, item) {
    var isCadeau = item.variant_id === GIFT;

    var titel = el.querySelector('[data-lf-titel]');
    if (titel.textContent !== item.product_title) titel.textContent = item.product_title;

    var variant = el.querySelector('[data-lf-variant]');
    var variantTekst = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';

    /* Personalisatie (naam/rugnummer op voetbalshirts) meeschrijven op de
       regel, zodat de klant in de lade ziet wat er op het shirt komt. Sleutels
       die met een underscore beginnen zijn intern en blijven onzichtbaar. */
    if (item.properties) {
      for (var eigenschap in item.properties) {
        if (eigenschap.charAt(0) === '_' || !item.properties[eigenschap]) continue;
        variantTekst += (variantTekst ? ' · ' : '') + eigenschap + ': ' + item.properties[eigenschap];
      }
    }

    variant.hidden = !variantTekst;
    if (variantTekst && variant.textContent !== variantTekst) variant.textContent = variantTekst;

    var label = el.querySelector('[data-lf-label]');
    label.hidden = !isCadeau;
    if (isCadeau && label.textContent !== TEKST_GRATIS) label.textContent = TEKST_GRATIS;

    // cadeau: geen stepper en geen kruisje, het wordt automatisch beheerd
    el.querySelector('[data-lf-stepper]').hidden = isCadeau;
    el.querySelector('[data-lf-verwijder]').hidden = isCadeau;

    var hoeveel = el.querySelector('[data-lf-hoeveel]');
    var nieuwAantal = String(item.quantity);
    if (hoeveel.textContent !== nieuwAantal) hoeveel.textContent = nieuwAantal;

    var prijs = el.querySelector('[data-lf-prijs]');
    var prijsTekst = (isCadeau || item.final_line_price === 0) ? TEKST_GRATIS : geld(item.final_line_price);
    if (prijs.textContent !== prijsTekst) prijs.textContent = prijsTekst;

    vulMaat(el, item, isCadeau);
  }

  /* Regels bijwerken in plaats van opnieuw opbouwen: bestaande regels blijven
     staan (dus geen herladende foto's en geen springende scrollpositie). */
  function tekenRegels(c) {
    var gewenst = c.items.filter(function (i) { return i.variant_id !== BESCHERM; });
    var bestaand = {};
    var kinderen = elRegels.querySelectorAll('[data-lf-regel]');
    for (var i = 0; i < kinderen.length; i++) {
      bestaand[kinderen[i].getAttribute('data-lf-regel')] = kinderen[i];
    }

    var vorige = null;
    gewenst.forEach(function (item) {
      var el = bestaand[item.key];
      if (el) {
        delete bestaand[item.key];
      } else {
        el = maakRegel(item);
      }
      vulRegel(el, item);
      // op de juiste plek zetten zonder onnodig te verplaatsen
      var verwacht = vorige ? vorige.nextSibling : elRegels.firstChild;
      if (el !== verwacht) elRegels.insertBefore(el, verwacht);
      vorige = el;
    });

    Object.keys(bestaand).forEach(function (k) { bestaand[k].remove(); });
  }

  function teken(c) {
    var sub = subtotaalExclCadeau(c);
    var echt = aantalEchteProducten(c);
    var bescherm = beschermingItem(c);

    root.classList.toggle('is-leeg', echt === 0);

    var zichtbaarAantal = c.item_count - (bescherm ? bescherm.quantity : 0);
    elAantal.textContent = zichtbaarAantal;
    werkBubbelBij(zichtbaarAantal);

    elSubtotaal.textContent = geld(c.original_total_price);
    elTotaal.textContent = geld(c.total_price);
    if (elKortingrij) {
      var korting = c.original_total_price - c.total_price;
      elKortingrij.hidden = korting <= 0;
      if (elKortingbedrag) elKortingbedrag.textContent = '−' + geld(korting);
    }

    if (elBescherming) {
      elBescherming.hidden = echt === 0;
      elBescherming.classList.toggle('is-aan', !!bescherm);
      if (elBeschermingToggle) elBeschermingToggle.checked = !!bescherm;
    }

    /* De ladder verdwijnt alleen als er van GEEN enkel behaald cadeau iets
       terechtkomt (de kassa weigerde ze allemaal, bijvoorbeeld omdat een
       andere korting won). Zolang minstens één cadeau doorgaat, blijft de
       ladder staan en toont hij de behaalde mijlpalen met een vinkje — eerder
       verdween hij al zodra alleen de sókken geweigerd waren, terwijl de
       boxershorts gewoon in de wagen lagen (gemeten 16 aug 2026). */
    var behaaldeTiers = TIERS.filter(function (t) { return sub >= t.drempel; });
    var cadeauVervallen = CADEAU_BEWAKING && behaaldeTiers.length > 0 &&
      behaaldeTiers.every(function (t) {
        return geweigerdBij[t.id] === sleutel(sub, echt);
      });
    if (elVoortgang) elVoortgang.hidden = cadeauVervallen;

    tekenLadder(sub);
    tekenCadeauknop(sub);

    /* Met een ladder is de losse balk dubbelop: de ladder toont de voortgang al. */
    var laatsteDrempel = TIERS.length ? TIERS[TIERS.length - 1].drempel : DREMPEL;
    var meetlat = LADDER_AAN ? laatsteDrempel : DREMPEL;
    if (elBalk && elBalk.parentElement) elBalk.parentElement.hidden = LADDER_AAN;

    var pct = meetlat > 0 ? Math.min(100, (sub / meetlat) * 100) : 100;
    elBalk.style.width = pct + '%';

    // drempel gehaald: balk verbergen, alleen de bevestigingsregel houden
    root.classList.toggle('is-gehaald', sub >= (LADDER_AAN ? laatsteDrempel : DREMPEL) && !cadeauVervallen);

    /* De zin benoemt altijd het EERSTVOLGENDE doel voluit. Dat is de reden dat
       de mijlpalen zelf met een bedrag toe kunnen: de naam staat hier al.
       Het resterende bedrag wordt afgekapt op nul — een drempel die gehaald is
       levert nooit een negatief bedrag op. */
    var volgendeTier = TIERS.filter(function (t) { return sub < t.drempel; })[0];
    var open = nogTeKiezen(sub).length;

    if (open > 0) {
      /* Er staat nog een cadeau open. Dat weegt zwaarder dan "gelukt": de klant
       is nog niet klaar, en zonder keuze komt het cadeau niet in de wagen.
       Bewust geteld op het aantal openstaande keuzes en niet op welke tier
       dat is — zo klopt de zin ook als er ooit een vierde tier bij komt. */
      elTekst.textContent = open === 1 ? T.nogEen : T.nogMeer.replace('[n]', open);
    } else if (!volgendeTier) {
      elTekst.innerHTML = '<span class="lf-cart__vinkje">✓</span>' +
        (LADDER_AAN ? TEKST_NA_LADDER : TEKST_NA);
    } else {
      var restant = Math.max(0, volgendeTier.drempel - sub);
      var zin = TEKST_VOOR.replace('{bedrag}', geld(restant));
      if (LADDER_AAN && volgendeTier.label) {
        zin = zin.replace(/gratis .*$/i, 'gratis ' + volgendeTier.label.toLowerCase());
      }
      elTekst.textContent = zin;
    }

    tekenRegels(c);
    tekenKorting();
  }

  function markeerBezig(key, bezig) {
    var el = elRegels.querySelector('[data-lf-regel="' + key + '"]');
    if (el) el.classList.toggle('is-bezig', !!bezig);
  }

  function allesKlaar() {
    var bezig = elRegels.querySelectorAll('.is-bezig');
    for (var i = 0; i < bezig.length; i++) bezig[i].classList.remove('is-bezig');
    if (elBescherming) elBescherming.classList.remove('is-bezig');
  }

  /* ---------- schrijven naar de server ---------- */

  function inKeten(werk) {
    keten = keten.then(werk, werk);
    return keten;
  }

  /* Eén gebundelde schrijfactie voor alles wat in het klikvenster veranderde.
     /cart/update.js accepteert meerdere regels tegelijk en geeft de hele
     winkelwagen terug, dus dit is altijd precies één netwerkcall. */
  function stuur() {
    timer = null;
    var taken = wachtend;
    wachtend = {};
    var sleutels = Object.keys(taken);
    if (!sleutels.length) return keten;

    /* Wat verzoen() straks toch zou beslissen, gaat nu in dezelfde aanroep mee.
       Een klik op + of − die de drempel passeert kostte twee rondgangen achter
       elkaar: eerst het aantal, dan het cadeau. Nu is het er één.

       Mag dat? Ja: de lokale winkelwagen is op dit moment al bijgewerkt met de
       wijziging van de klant (stap() en verwijder() doen dat vóór plan()), en
       de drempel wordt gemeten op original_line_price, dat we lokaal exact
       narekenen. De beslissing is dus dezelfde als die verzoen() zou nemen.
       Zit de klant er toch naast, dan corrigeert verzoen() het alsnog op het
       antwoord van de server. */
    var extras = bepaalExtras(cart);
    for (var k in extras) {
      if (Object.prototype.hasOwnProperty.call(extras, k) &&
          !Object.prototype.hasOwnProperty.call(taken, k)) {
        taken[k] = extras[k];
      }
    }

    return inKeten(function () {
      return api('/cart/update.js', { updates: taken })
        .then(verzoen)
        .then(function (c) { cart = c; teken(c); allesKlaar(); haalMaten(); })
        .catch(function () {
          // netwerkfout: terug naar de echte serverstaat, niets stilzwijgend fout laten staan
          return haalCart().then(function (c) { cart = c; teken(c); allesKlaar(); });
        });
    });
  }

  function plan() {
    if (timer) clearTimeout(timer);
    timer = setTimeout(stuur, WACHTTIJD);
  }

  /* ---------- acties ---------- */

  function vindItem(key) {
    if (!cart) return null;
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].key === key) return cart.items[i];
    }
    return null;
  }

  /* Klik op + of −: eerst lokaal doorrekenen en tekenen, dan pas versturen. */
  function stap(key, delta) {
    var item = vindItem(key);
    if (!item) return;

    /* OMHOOG MAG NIET BOVEN DE VOORRAAD.
       /cart/update.js controleert dat zelf niet — zonder deze grens komt er
       gewoon een derde stuk in de wagen terwijl er twee op voorraad zijn, en
       strandt de klant pas op de voorraadpagina van de checkout. Liever hier
       een eerlijke melding op de regel dan daar een dood spoor. */
    if (delta > 0) {
      var grens = voorraadGrens(key);
      if (grens !== null && item.quantity + delta > grens) {
        var m = MATEN[key];
        var anderen = m && m.varianten ? m.varianten.filter(function (v) {
          return v.id !== item.variant_id && v.beschikbaar;
        }).length : 0;
        regelFout(key, grens === 1
          ? 'Er is er nog maar één — en die ligt al in je winkelwagen.' + (anderen ? ' Andere maat kiezen kan hieronder.' : '')
          : 'Er zijn er maar ' + grens + ' op voorraad.' + (anderen ? ' Andere maat kiezen kan hieronder.' : ''));
        return;
      }
    }

    var nieuw = Math.max(0, item.quantity + delta);
    item.quantity = nieuw;
    item.final_line_price = item.final_price * nieuw;
    item.original_line_price = item.original_price * nieuw;
    if (nieuw === 0) {
      cart.items = cart.items.filter(function (i) { return i.key !== key; });
    }
    herbereken(cart);

    wachtend[key] = nieuw;
    teken(cart);
    markeerBezig(key, true);
    plan();
  }

  function verwijder(key) {
    var item = vindItem(key);
    if (!item) return;
    cart.items = cart.items.filter(function (i) { return i.key !== key; });
    herbereken(cart);
    wachtend[key] = 0;
    teken(cart);
    plan();
  }

  /* Totalen lokaal opnieuw uitrekenen na een optimistische wijziging.
     De server corrigeert dit zo nodig bij het antwoord. */
  function herbereken(c) {
    c.item_count = c.items.reduce(function (n, i) { return n + i.quantity; }, 0);
    c.items_subtotal_price = c.items.reduce(function (s, i) { return s + i.final_line_price; }, 0);
    c.original_total_price = c.items.reduce(function (s, i) { return s + i.original_line_price; }, 0);
    c.total_price = c.items_subtotal_price;
  }

  function zetBescherming(aan) {
    if (!BESCHERM || !cart) return Promise.resolve();

    // optimistisch: toggle en totalen meteen bijwerken
    var huidig = beschermingItem(cart);
    if (aan && !huidig) {
      cart.items.push({
        key: 'lf-bescherming-tijdelijk',
        variant_id: BESCHERM,
        product_title: 'Verzendbescherming',
        variant_title: '',
        quantity: 1,
        final_price: 395,
        original_price: 395,
        final_line_price: 395,
        original_line_price: 395,
        image: null
      });
    } else if (!aan && huidig) {
      cart.items = cart.items.filter(function (i) { return i.variant_id !== BESCHERM; });
    }
    herbereken(cart);
    teken(cart);
    if (elBescherming) elBescherming.classList.add('is-bezig');

    return inKeten(function () {
      var updates = {};
      updates[BESCHERM] = aan ? 1 : 0;
      return api('/cart/update.js', { updates: updates })
        .then(verzoen)
        .then(function (c) { cart = c; teken(c); allesKlaar(); })
        .catch(function () {
          return haalCart().then(function (c) { cart = c; teken(c); allesKlaar(); });
        });
    });
  }

  /* ---------- kortingscode ---------- */

  function tekenKorting() {
    var veld = root.querySelector('[data-lf-korting-veld]');
    var actief = root.querySelector('[data-lf-korting-actief]');
    var link = root.querySelector('[data-lf-korting-open]');
    var code = root.querySelector('[data-lf-korting-code]');
    if (!actief || !code) return;

    if (kortingscode) {
      code.textContent = kortingscode;
      actief.hidden = false;
      if (veld) veld.hidden = true;
      if (link) link.hidden = true;
      elAfrekenen.setAttribute('href', CHECKOUT_URL + '?discount=' + encodeURIComponent(kortingscode));
    } else {
      actief.hidden = true;
      if (link) link.hidden = false;
      elAfrekenen.setAttribute('href', CHECKOUT_URL);
    }
  }

  function zetKortingscode(nieuw) {
    kortingscode = (nieuw || '').trim().toUpperCase();
    try {
      if (kortingscode) window.sessionStorage.setItem('lfKortingscode', kortingscode);
      else window.sessionStorage.removeItem('lfKortingscode');
    } catch (e) { /* privémodus: dan alleen in het geheugen */ }
    tekenKorting();
  }

  /* ---------- openen en sluiten ---------- */

  /* Korte samenvatting van de winkelwagen, om te zien of verzoen() hem heeft
     aangepast. Alleen de dingen waar de staffelmelding op reageert. */
  function vingerafdruk(c) {
    if (!c || !c.items) return '';
    return c.items.map(function (i) { return i.key + ':' + i.quantity; }).join(',');
  }

  function sync() {
    return inKeten(function () {
      /* De staffelmelding lift normaal mee op de wijzigingsaanroepen van de
         lade zelf. Maar een winkelwagen kan ook buiten de lade om veranderen —
         snel-toevoegen vanaf een productkaart doet dat — en /cart.js kan geen
         secties meesturen. Daarom halen we hem hier los op.

         Hij wacht níét op /cart.js: allebei de verzoeken vertrekken tegelijk.
         Dat scheelt bij het openen van de lade een hele rondgang. Verandert
         verzoen() de wagen alsnog — het cadeau erin of eruit — dan klopt de
         melding niet meer en halen we hem opnieuw op. In het gewone geval,
         waarin er niets verandert, is die tweede aanroep niet nodig. */
      var meldingVooraf = ververStaffelmelding();

      return haalCart().then(function (ruw) {
        var voor = vingerafdruk(ruw);
        return verzoen(ruw).then(function (c) {
          cart = c; teken(c); allesKlaar();
          if (vingerafdruk(c) === voor) {
            return meldingVooraf.then(function () { return c; });
          }
          return ververStaffelmelding().then(function () { return c; });
        });
      });
    });
  }

  function ververStaffelmelding() {
    /* Sinds 7 september 2026 geen netwerkverzoek meer: de sectie bestaat niet
       (404 op elke pagina). De houder wordt leeggemaakt en de rest van de lade
       merkt er niets van; de aanroepers krijgen dezelfde belofte terug. */
    zetStaffelmelding('');
    return Promise.resolve();
  }

  /* Waar de focus vandaan kwam toen de lade openging. Bij het sluiten gaat
     hij daar terug naartoe — wie met het toetsenbord werkt raakt anders zijn
     plek op de pagina kwijt. */
  var focusHerkomst = null;

  function open() {
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    document.documentElement.classList.add('lf-cart-open');
    if (cart) teken(cart); // meteen iets tonen, de sync loopt erachteraan
    sync();
    haalMaten();

    focusHerkomst = document.activeElement;
    /* De focus de lade in, op de sluitknop — het eerste bedienbare element.
       Na de openanimatie, anders scrollt de browser naar een element dat er
       visueel nog niet staat. */
    setTimeout(function () {
      var sluitknop = root.querySelector('.lf-cart__sluiten');
      if (sluitknop && root.classList.contains('is-open')) sluitknop.focus();
    }, 120);
  }

  function sluit() {
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    document.documentElement.classList.remove('lf-cart-open');
    if (focusHerkomst && typeof focusHerkomst.focus === 'function' && document.contains(focusHerkomst)) {
      focusHerkomst.focus();
    }
    focusHerkomst = null;
  }

  /* DE FOCUS BLIJFT IN DE LADE ZOLANG HIJ OPEN IS.
     Tab op het laatste element springt terug naar het eerste en andersom.
     Zonder dit tabt een toetsenbordgebruiker de onzichtbare pagina eronder in
     en is hij zijn plek kwijt. Elke keer vers gemeten welke elementen er
     bedienbaar zijn: de inhoud van de lade verandert voortdurend. */
  root.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || !root.classList.contains('is-open')) return;
    var paneel = root.querySelector('.lf-cart__paneel');
    var alles = paneel.querySelectorAll('button, a[href], select, input, [tabindex]:not([tabindex="-1"])');
    var lijst = [];
    for (var i = 0; i < alles.length; i++) {
      var el = alles[i];
      if (el.disabled || el.hidden || el.closest('[hidden]')) continue;
      if (!el.getBoundingClientRect().height) continue;
      lijst.push(el);
    }
    if (!lijst.length) return;
    var eerste = lijst[0], laatste = lijst[lijst.length - 1];
    if (e.shiftKey && document.activeElement === eerste) { e.preventDefault(); laatste.focus(); }
    else if (!e.shiftKey && document.activeElement === laatste) { e.preventDefault(); eerste.focus(); }
  });

  /* ---------- gebeurtenissen ---------- */

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-lf-sluit]')) { sluit(); return; }

    var regel = e.target.closest('[data-lf-regel]');

    var stapKnop = e.target.closest('[data-lf-stap]');
    if (stapKnop && regel) {
      stap(regel.getAttribute('data-lf-regel'), parseInt(stapKnop.dataset.lfStap, 10));
      return;
    }

    if (e.target.closest('[data-lf-verwijder]') && regel) {
      verwijder(regel.getAttribute('data-lf-regel'));
      return;
    }

    if (e.target.closest('[data-lf-korting-open]')) {
      var veld = root.querySelector('[data-lf-korting-veld]');
      if (veld) {
        veld.hidden = !veld.hidden;
        if (!veld.hidden) veld.querySelector('[data-lf-korting-invoer]').focus();
      }
      return;
    }

    if (e.target.closest('[data-lf-korting-toepassen]')) {
      var invoer = root.querySelector('[data-lf-korting-invoer]');
      if (invoer && invoer.value.trim()) { zetKortingscode(invoer.value); invoer.value = ''; }
      return;
    }

    if (e.target.closest('[data-lf-korting-wissen]')) { zetKortingscode(''); return; }
  });

  root.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.hasAttribute('data-lf-korting-invoer')) {
      e.preventDefault();
      if (e.target.value.trim()) { zetKortingscode(e.target.value); e.target.value = ''; }
    }
  });

  root.addEventListener('change', function (e) {
    if (e.target.hasAttribute('data-lf-bescherming-toggle')) zetBescherming(e.target.checked);

    if (e.target.hasAttribute('data-lf-maat-select')) {
      var regel = e.target.closest('[data-lf-regel]');
      if (regel) wisselMaat(regel.getAttribute('data-lf-regel'), parseInt(e.target.value, 10));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('is-open')) sluit();
  });

  /* NIET WEGHALEN BIJ EEN HERSCHRIJVING.
     Zonder deze regel opent een klik op het winkelwagen-icoon de lade van
     Impulse in plaats van die van LodyFair. Dit is de enige weg waarlangs een
     bezoeker de lade zelf opent; de rest gaat via 'in winkelwagen'. */
  document.addEventListener('click', function (e) {
    var link = e.target.closest ? e.target.closest('a[href$="/cart"], .js-drawer-open-cart') : null;
    if (!link) return;
    e.preventDefault();
    e.stopPropagation();
    open();
  }, true);

  /* Impulse opent bij 'in winkelwagen' zijn eigen lade (cart_type = drawer).
     Deze listener staat er eerder dan die van Impulse — dit script draait als
     defer vóór DOMContentLoaded, Impulse start pas daarna — dus met
     stopImmediatePropagation blijft die lade dicht en openen wij de onze. */
  document.addEventListener('ajaxProduct:added', function (e) {
    e.stopImmediatePropagation();
    open();
  }, true);

  /* Ook syncen wanneer elders iets aan de cart verandert (bv. productpagina) */
  document.addEventListener('cart:build', function () { sync(); });

  /* Als de pagina verborgen raakt terwijl er nog iets klaarstaat: nu versturen. */
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden' && Object.keys(wachtend).length) {
      if (timer) clearTimeout(timer);
      stuur();
    }
  });

  /* Nooit met een openstaande wijziging naar de kassa. */
  root.addEventListener('click', function (e) {
    var afrekenen = e.target.closest('[data-lf-afrekenen]');
    if (!afrekenen) return;
    if (!Object.keys(wachtend).length && !timer) return;
    e.preventDefault();
    if (timer) clearTimeout(timer);
    stuur().then(function () { window.location.href = afrekenen.getAttribute('href'); });
  });

  window.lfCart = {
    open: open,
    sluit: sluit,
    sync: sync,
    stap: stap,
    verwijder: verwijder,
    zetBescherming: zetBescherming,
    zetKortingscode: zetKortingscode,
    _verzoen: verzoen,
    _subExcl: subtotaalExclCadeau,
    _cart: function () { return cart; }
  };
  sync();
})();
